@if (form) {
  <form [formGroup]="form" (ngSubmit)="search()" class="row">
    <div class="row">
      <rask-input class="col-2" aid="inputHandelssortimentNamn" label="{{ 'HANDELSSORTIMENT_LIST_NAMN' | translate }}" formControlName="namn" [rule]="">
      </rask-input>
      <rask-input class="col-2" aid="inputHandelssortimentHandelssortimentsgruppKod" label="{{ 'HANDELSSORTIMENT_LIST_HANDELSSORTIMENTSGRUPP' | translate }}"
        formControlName="handelssortimentsgrupp" [rule]="">
      </rask-input>
      <rask-input class="col-1" aid="inputHandelssortimentProdukt" label="{{ 'HANDELSSORTIMENT_LIST_PRODUKT' | translate }}" formControlName="produktnamn" [rule]="">
      </rask-input>
      <rask-input class="col-1" aid="inputHandelssortimentSortimentsKod" label="{{ 'HANDELSSORTIMENT_LIST_SORTIMENTKOD' | translate }}" formControlName="sortimentskod"
        [rule]="">
      </rask-input>
      <rask-input class="col-2" aid="inputHandelssortimentBeteckning" label="{{ 'HANDELSSORTIMENT_LIST_BETECKNING' | translate }}" formControlName="beteckning" [rule]="">
      </rask-input>
      <rask-checkbox class="col-1" text="För produktion" formControlName="forProduktion"></rask-checkbox>
      <rask-checkbox class="col-1" text="För inmätning" formControlName="forInmatning"></rask-checkbox>
    </div>
    <div class="row">
      <rask-radiobutton-group class="col-2" aid="aktivRadio" label="{{ 'HANDELSSORTIMENT_LIST_AKTIV' | translate }}" [buttons]="activetypes"
        formControlName="aktivFormValue">
      </rask-radiobutton-group>
      <div class="d-flex col-4">
        <rask-submit-button color="secondary" aid="handelssortimentSok">{{ 'DEFAULT_BUTTON_LABEL_SOK' | translate }}</rask-submit-button>
        <rask-button aid="buttonRensa" color="secondary" negative  (click)="rensaSokFilter()">Rensa</rask-button>
      </div>
    </div>
  </form>
}
